import React from 'react';
import { ActiveLocale, CaretArrow, ChevronArrow, SelectorLanguageIcon } from '../styles';
export var LanguageSelectorIcon = function LanguageSelectorIcon(_ref) {
  var langCode = _ref.langCode,
      signedIn = _ref.signedIn;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(SelectorLanguageIcon, null), /*#__PURE__*/React.createElement(ActiveLocale, {
    variant: "body2"
  }, langCode), signedIn ? /*#__PURE__*/React.createElement(ChevronArrow, {
    size: "xsmall",
    "aria-hidden": "true"
  }) : /*#__PURE__*/React.createElement(CaretArrow, {
    size: "xsmall",
    "aria-hidden": "true"
  }));
};